import React, { useState, useEffect } from "react";
import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'

//var dateFormat = require('dateformat');

const RenderWpForm = () => {

const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
const resturl=sessionStorage.getItem("RESTURL");

//var boolFetchingSads=false;


const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});

const [vchroptions, setVchroptions] = useState({vchrtype:''});


const [renders, setRenders] = useState({count:0});
const [email, setEmail] = useState({MESSAGE:''});

const [udak, setUdak] = useState([]);

const [tbludakvsa1, setTbludakvsa1] = useState([]);
const [tbludakvsa2, setTbludakvsa2] = useState([]);
const [vsaapp, setVsaapp] = useState({VSA_APP_ID:0});

const [dowait, setDowait] = useState({show:false});
const [dlwait, setDlwait] = useState({show:false});


const [TOTAL_EMPTY_FIELDS, setTOTAL_EMPTY_FIELDS] = useState({NUM:500});






const location = useLocation();


useEffect(() => {



if (sessionStorage.getItem("IRD_LOGIN_ID")==null || sessionStorage.getItem("IRD_LOGIN_ID")=="null" || sessionStorage.getItem("IRD_LOGIN_ID")==undefined || sessionStorage.getItem("IRD_LOGIN_ID")==""){
	navigate("/dashboard");
	return;
	}//end if

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if
	
if (location.state.VSA_APP_ID!=null && location.state.VSA_APP_ID!=undefined && location.state.VSA_APP_ID!='null' && location.state.VSA_APP_ID!='undefined'){
	setVsaapp({VSA_APP_ID:location.state.VSA_APP_ID});
	//getwpformoptions();
	}//end if
else
	console.log("location.state.VSA_APP_ID not provided");
	//qrylabor();
 },[]);

useEffect(() => {
//console.log("useEffect"+vsaapp.VSA_APP_ID);
if (vsaapp.VSA_APP_ID>0){
	if (udak.length==0)
		gettblvsaappudak();
	
	if (vsaapp.REF_NUM==undefined){
		getvsaapp();
		}//end func
	else if (vsaapp.STATUS==null)
		setVsaappStatus();
	}//end if
 },[vsaapp]);

 
useEffect(() => {
	console.log("useEffect vchroptions.vchrtype: "+vchroptions.vchrtype);
	if (vchroptions.vchrtype!=''){
		const elem=vchroptions.vchrtype+'AMT[]';
		if (document.getElementsByName(elem)[0])
			document.getElementsByName(elem)[0].focus();
		}//end if
	
	
 },[vchroptions.vchrtype]);
 
 
useEffect(() => {
	console.log("useEffect udak.length: "+udak.length);

if (udak.length>0)
	dosetTbludakvsa1();
else{
	setTbludakvsa1([]);
	}//end else
	

},[JSON.stringify(udak)]);

useEffect(() => {
//console.log('udak[0]: '+JSON.stringify(udak[0]));

if (udak.length>0 && tbludakvsa1.length>0){
	//console.log('udak.NUM_LC_DOCS: '+udak[0].NUM_LC_DOCS);
	if (udak[0].NUM_WP_DOCS==0){
		//callSetVchroptions('wp');
		//document.getElementById('rdwpvchr').checked=true;
		}//end if
	}//end if
 },[JSON.stringify(tbludakvsa1)]);


function setVsaappStatus(){

		setVsaapp((prev)=>{
	return {...prev, IRD_LOGIN_ID:sessionStorage.getItem("IRD_LOGIN_ID")};
	
});
	const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {VSA_APP_ID:vsaapp.VSA_APP_ID, STATUS:"CHECK"} )
  };		

  fetch(resturl+'rarvsaform/setVsaappstatus',requestOptions)
      .then(res => res.json())
      .then(res => 	aftersetVsaappstatus(res) )
      .catch(err => console.log(err));
	  
}//end func

function aftersetVsaappstatus(res){
setVsaapp((prev) => {
return {...prev
, STATUS:"CHECK"
}});
/*
, CHR_ORGL_DOCS_DATE:res[0].CHR_ORGL_DOCS_DATE
, ORGL_DOCS_USER:res[0].ORGL_DOCS_USER

*/
}//end func


function getvsaapp(e){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {VSA_APP_ID:vsaapp.VSA_APP_ID} )
  };		

  fetch(resturl+'rarvsaform/getvsaapp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetvsaapp(res) )
      .catch(err => console.log(err));
	  

}//end func

function aftergetvsaapp(res){
setVsaapp(res[0]);
{/*
console.log('aftergetvsaapp res[0].PERSON_ID: '+res[0].PERSON_ID);
if (res[0].PERSON_ID==null)
	navigate('/person',{state:{VSA_APP_ID:vsaapp.VSA_APP_ID}});

*/}	
}//end func

async function getprepinsertdoc(e){

document.getElementById("tblsteps").scrollIntoView();
console.log("vchroptions.vchrtype: "+vchroptions.vchrtype);
const result=await confirm('payment vouchers will be created. proceed?');
if (!result)
	return;

document.getElementById('btinsertprepdoc').style.visibility='hidden';

let requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( {WPT_APP_ID:vsaapp.VSA_APP_ID, USERNAME:sessionStorage.getItem("USERNAME"), VCHR_TYPE:vchroptions.vchrtype } )
};		

fetch(resturl+'rarwpform/getprepinsertdoc',requestOptions)
  .then(res => res.json())
  .then(res => 	insertprepdoc(res) )
  .catch(err => console.log(err));	

  
}//end func

function insertprepdoc(res){
	
console.log('insertprepdoc res: '+JSON.stringify(res));
if (!res.length){
	showsnackbar("no records were found to send for voucher creation.<br/>please try again or contact admin.");
	return;
	}//end if
	
const requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( res )
};		
//rarvsaapp
fetch(customspremurl+'rarwptapp/insertprepdoc',requestOptions)
  .then(res => res.json())
  .then(res => 	afterinsertprepdoc(res) )
  .catch(err => console.log(err));	
	
}//end func

async function afterinsertprepdoc(res){
	//console.log('afterinsertprepdoc'+JSON.stringify(res));
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {docs:res, SEQ_NO:udak[0].SEQ_NO, VSA_APP_ID:vsaapp.VSA_APP_ID, USERNAME:sessionStorage.getItem("USERNAME")} )
  };		

await  fetch(resturl+'rarvsaform/updatedocno',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdatedocno(res) )
      .catch(err => console.log(err));	
	
}//end func

function afterupdatedocno(res){
navigate('/vsaform', {state:{VSA_APP_ID:vsaapp.VSA_APP_ID,SCTN:'16'}});
	{/*
	//reload the table
	aftergettblvsaappudak(res);
	showsnackbar('document numbers should be displayed. an email will be sent to customer with the vouchers attached');
	*/}
}

function gettblvsaappudak(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {VSA_APP_ID:vsaapp.VSA_APP_ID, USERNAME:sessionStorage.getItem("USERNAME")} )
  };		

	setUdak([]);
	
  fetch(resturl+'rarvsaform/gettblvsaappudak',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblvsaappudak(res) )
      .catch(err => console.log(err));

}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func

function handleChange(e, index){
	//console.log('handleChange udak:'+JSON.stringify(udak));
	console.log('handleChange index:'+index);
	
	let tempudak=udak;
	if (e.target.name=='VCHR_COMMENT[]')
		tempudak[index].VCHR_COMMENT=e.target.value;
	else{
		//first strip away all non-numeric
		const amt=e.target.value.replace(/[^\d.]/g, '');
		//console.log("amt: "+amt);
		e.target.value=amt;
		tempudak[index].AMOUNT=amt;
		}//end else
		
	
	setUdak(tempudak);
	document.getElementById('btnsavechanges').style.visibility='visible';
	if (document.getElementById('btinsertprepdoc'))
		document.getElementById('btinsertprepdoc').style.visibility='hidden';
	
}

function aftergettblvsaappudak(res){
setDowait({show:false});
if (res.length==undefined)
	return;
console.log('aftergettblvsaappudak udak.length: '+udak.length);
setUdak(res);
}//end funcs

function dosetTbludakvsa1(){

let v1htmrows=[], v2htmrows=[];

console.log('udak.length : '+udak.length);

udak.map((col, index) => {
	//console.log('dosetTbludakvsa1 col: '+JSON.stringify(col));
	const trkey='tr_'+index;
	const tdkey='td_'+index;
	const typ=col.VCHR_TYPE;
//<td align='center'   >{col['DOC_NO']}</td>
// <tr key={trkey} ><td  key={'1'+tdkey} >test</td></tr>
	let htmrow=[];
	htmrow.push(<tr>
	<td align='center' key={index+"c0"}   >{col.ACCOUNT}</td>
	
	<td align='center'   ><input type="text" name={typ+'AMT[]'} key={"input"+index} autoComplete='off' defaultValue={col.AMOUNT} onChange={(e)=>{handleChange(e, index);}} onFocus={(e)=>{e.target.select();}} size="9" style={{textAlign:"right"}} /></td>
	<td align='left'   >{col.ACCT_DESCP_1}</td>
	<td align='center'   >{col.MODIFY_USER}</td>
	<td align='center'   >{col.CHR_MODIFY_DATE}</td>
</tr>);
    if (udak[index].VCHR_COMMENT!=null ){
		htmrow.push(<tr>
		<td align='center' key={index+"c1"}  >&nbsp;</td>
		<td align='center' key={index+"c2"}  >&nbsp;</td>
		<td align='left' key={index+"c3"} colSpan="4"   ><textarea name='VCHR_COMMENT[]'  key={"textarea"+index}  defaultValue={col.VCHR_COMMENT} onChange={(e)=>{handleChange(e, index);}} onFocus={(e)=>{e.target.select();}} rows="3" cols="80" ></textarea></td>

		</tr>);
		}
	

	if (typ=='V1')
		v1htmrows.push(htmrow);
	else
		v2htmrows.push(htmrow);
});

setTbludakvsa1(v1htmrows);
setTbludakvsa2(v2htmrows);

}//end func

function mkvouchers(){
}

function senddeferemail(){
	
	
	
	const checked=document.getElementById('cbsendemail').checked;
	if (checked==false){
		alert('tick the checkbox if you are ready');
		return;
		}

	if (email.MESSAGE==''){
		alert('there seems to be no message to send');
		return;
		}

setDowait({show:true});

const params={
	USERNAME:sessionStorage.getItem("USERNAME")
	, MESSAGE:email.MESSAGE
	, VSA_APP_ID:vsaapp.VSA_APP_ID
}

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

  fetch(resturl+'rarvsaform/senddeferemail',requestOptions)
      .then(res => res.json())
      .then(res => 	aftersenddeferemail(res) )
      .catch(err => console.log(err));			
	
}//end ufnc

function aftersenddeferemail(res){
	
	setDowait({show:false});
	
	if (res.length==undefined)
		showsnackbar('something went wrong.  please try again');
	else{
		toggleModalsm();
		alert('email was sent.  all done!');
		}
		
}

function savechanges(){

setDowait({show:true});
	setUdak([]);
	
	const username=sessionStorage.getItem("USERNAME");
	const params={
		udak:udak
		, VSA_APP_ID:vsaapp.VSA_APP_ID
	, LATE_FEE:vchroptions.latefee
	, USERNAME:username};
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

  fetch(resturl+'rarvsaform/updatevsaappudak',requestOptions)
      .then(res => res.json())
      .then(res => 	aftersavechanges(res) )
      .catch(err => console.log(err));	
	
}//end func



function callSetVchroptions(e){
const [name, value]=[e.target.name, e.target.value];
console.log("callSetVchroptions name: "+name);

	setVchroptions((prev)=>{
		return {...prev, [name]:value}	
	});
	
}//end func

function enableAmountInputOld(flag){
	
/*
setVchroptions((prev)=>{
	return {...prev, vchrtype:flag}	
});


let wpelem=document.getElementsByName('WPAMT[]');
for (var i=0; i<wpelem.length; i++){
	wpelem[i].readOnly=true;
	wpelem[i].classList.add("gnsbro");
	}//end for
	
flag=flag.toUpperCase();
let elem=document.getElementsByName(flag+'AMT[]');
//var i=0; len=elem.length;
for (var i=0; i<elem.length; i++){
	elem[i].readOnly=false;
	elem[i].classList.remove("gnsbro");
	}//end for

*/


}//end func

function aftersavechanges(res){
	aftergettblvsaappudak(res);
	setDowait({show:false});
	//setDowait({show:false});
	//gettblvsaappudak();
	
}//end func


function setemailmessage(){
const msg=document.getElementsByName('emailmsg')[0].value;
setEmail((prev)=>{
	return {...prev, MESSAGE:msg}

});
}//end func





function toggleModalsm() {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");

if (document.querySelector(".trigger"))
	document.querySelector(".trigger").addEventListener("click", toggleModalsm);

if (document.querySelector(".close-button"))
	document.querySelector(".close-button").addEventListener("click", toggleModalsm);

window.addEventListener("click", windowOnClick);
}//end func

async function clearvsaappudak(e){
e.preventDefault();
document.getElementById("tblsteps").scrollIntoView();
const result=await confirm('reset the table and start over?');	
if (!result)
	return;


const requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( {VSA_APP_ID:vsaapp.VSA_APP_ID, USERNAME:sessionStorage.getItem("USERNAME")} )
};

setDowait({show:true});
setUdak([]);
fetch(resturl+'rarvsaform/clearvsaappudak',requestOptions)
  .then(res => afterclearvsaappudak(res))
  .catch(err => console.log(err));

}//end func

function afterclearvsaappudak(res){
	setDowait({show:false});

	setVchroptions((prev)=>{
		return {...prev, vchrtype:''}
	});
	document.getElementById('rdv1vchr').checked=false;
	document.getElementById('rdv2pvchr').checked=false;
	gettblvsaappudak();
	

}//end func


function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");	
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }
}//end func


function vchroptionsChange(vchroption, e){

/*
	if (vchroption=="latefee")
		setVchroptions((prev)=>{return {...prev,latefee:e.target.checked?1:0}});
	else if (vchroption=="switchmpr")
		setVchroptions((prev)=>{return {...prev,switchmpr:e.target.checked?1:0}});

*/
	
	
}//end func


const IRD_LOGIN_ID=sessionStorage.getItem("IRD_LOGIN_ID");
const refnum=vsaapp.REF_NUM?vsaapp.REF_NUM:"";
const refurl=sessionStorage.getItem("UPLOADURL")+refnum+"/foto.png";
const imgsrc=resturl+"rarwpform/getwptappfoto?path="+vsaapp.REF_NUM+"/foto.png"
//const mpefoto=resturl+"rarvsaform/getvsaappfoto?path="+vsaapp.REF_NUM+"/foto.png";
console.log('imgsrc: '+imgsrc);
//refurl+"foto.png";
//const scanslink=refurl+"scans.pdf";
let orgl_docs=(vsaapp.ORGL_DOCS_DATE==null)?'':vsaapp.ORGL_DOCS_USER+' '+vsaapp.CHR_ORGL_DOCS_DATE;
	
  return (
    <>
	<p align='center' style={{marginBottom:"0px"}}>
	creating payment vouchers for Visa application with Ref # 
	<a href="#" title='go to application form fields' onClick={(e)=>{e.preventDefault(); navigate('/vsaform', {state:{VSA_APP_ID:vsaapp.VSA_APP_ID,SCTN:'16'}});}} >{refnum}</a> 
	
	</p>
	{/*vsaapp.PERSON_ID == null && <>
	<p  align='center' style={{color:"brown"}} > before creating payment vouchers, the foreign worker needs to be matched or created in Permit Management System</p>
	<p  align='center' ><a href='#' onClick={(e)=>{e.preventDefault();navigate('/person',{state:{VSA_APP_ID:vsaapp.VSA_APP_ID}});}} >click here to proceed</a></p>
	</>
	*/}
	{true &&  
	<table align='center' id='tblsteps' border="0" >
	<tbody>
	<tr  key="tr_STEP1" >
	<td align='left' colSpan="3" >
	<ul>
		<li>step 1: choose the application type then enter the dollar amounts and click save</li>
		<li>step 2: after the correct amounts have been saved, click the create vouchers button</li>
	</ul>
	</td>
	</tr>

	{/*
	<tr  key="tr_ORGL_DOCS" >
	<td align='right' ><input type='checkbox' id='cborgl' onClick={(e)=>{originalseen();}} /><label for ='cborgl' className='hand' >original docments seen</label>: </td>
	<td align='left' ><input  readOnly className='gnsbro' value={vsaapp.ORGL_DOCS_USER?vsaapp.ORGL_DOCS_USER+' '+vsaapp.CHR_ORGL_DOCS_DATE:''} /></td>
	</tr>
	<tr  key="tr_IRD_LOGIN_ID" >
	<td align='right' >Voucher Creation User: </td>
	<td align='left' >{IRD_LOGIN_ID}</td>
	</tr>
	STY_SUR_NAM
STY_GVN_NAM
VSA_TYP
VSR_SUR_NAM
VSR_GVN_NAM
	*/}	
	<tr  key="tr_EMAIL" >
	<td align='right' >Application Creator Username: </td>
	<td align='left'   >{vsaapp.CREATE_USER}</td>
	<td align='center'  rowSpan="6" >
		{vsaapp.REF_NUM!=undefined && <>
		<img src={imgsrc} border='0' height="150" />
			{/*<br/>Applicant: {vsaapp.VSR_GVN_NAM+' '+vsaapp.VSR_SUR_NAM}*/}
		</>
		}
	</td>
	</tr>
	<tr  key="tr_CREATE_USER" >
	<td align='right' >Application Creator Name: </td>
	<td align='left' >{vsaapp.WEB_USER_NAME}</td>
	</tr>
	<tr  key="tr_MPR_NAME" >
	<td align='right' >Surety's Name: </td>
	<td align='left' >{vsaapp.STY_GVN_NAM+' '+vsaapp.STY_SUR_NAM}</td>
	</tr>
	<tr  key="tr_VSR_NAME" >
	<td align='right' >Applicant's Name: </td>
	<td align='left' >{vsaapp.VSR_GVN_NAM+' '+vsaapp.VSR_SUR_NAM}</td>
	</tr>

	<tr key="key_tr_VSA_TYP" >
	<td align='right' >Visa Type:</td>
	<td align='left' >{vsaapp.VSA_TYP}</td>
	</tr>
	

	<tr key="key_tr_VCHR_TYP" >
	<td align='right' >Voucher Type:</td>
	<td align='left' >
		<input type='radio' name='vchrtype' id='rdv1vchr' value='V1' onClick={(e)=>{callSetVchroptions(e);}} /><label htmlFor='rdv1vchr' className="hand" >ADMIN FEES FOR A VISITOR VISA</label>
		<br/>
		<input type='radio' name='vchrtype' id='rdv2vchr' value='V2'  onClick={(e)=>{callSetVchroptions(e);}} /><label htmlFor='rdv2vchr' className="hand" >FEES FOR AN APPROVED VISITOR VISA</label>
	</td>
	</tr>

	<tr key="key_tr_RETURN" >
	<td align='right' ><a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); navigate("/vsaform", {state:{VSA_APP_ID:vsaapp.VSA_APP_ID}});  }}  ><img src="img/return.png" border="0" /> return to application</a></td>
	</tr>	

	
	</tbody>
	</table>
	}
	

	
	{vchroptions.vchrtype=='V1' && tbludakvsa1.length>=0 && <><p className="p_wpvouchers" >
	</p><table align='center' className='customers' style={{width:"65%"}} >
	<thead>
	<tr key="tr1" >
		<th>acc code</th>
		<th align='center' >amount to be paid</th>
		<th>account description</th>
		<th>updated by</th>
		<th>updated</th>
	</tr>
	</thead>
	<tbody>
		{tbludakvsa1}
	</tbody>
	</table>
	</>
	}

	{vchroptions.vchrtype=='V2' && tbludakvsa2.length>=0 && <><p className="p_wpvouchers" >
	</p><table align='center' className='customers' style={{width:"65%"}} >
	<thead>
	<tr key="tr2" >
		<th>acc code</th>
		<th align='center' >amount to be paid</th>
		<th>account description</th>
		<th>updated by</th>
		<th>updated</th>
	</tr>
	</thead>
	<tbody>
		{tbludakvsa2}
	</tbody>
	</table>
	</>
	}

<p align='center' >  
		
		{dowait.show && <span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span>}
		{
		!dowait.show && 
		<input type="button" id='btnsavechanges' className="button" value="save changes" onClick={(e)=>{ savechanges(); }}  />
		}
		{
			/*
		&nbsp;&nbsp;&nbsp;
		<input size='4' readOnly className='gnsbro' title='amount without voucher no.' defaultValue={udak[0]?.amttodo} />
			*/
			
		}		
		&nbsp;&nbsp;&nbsp;
		{udak[0]?.AMT_WITHOUT_DOC_NO>0 && vchroptions.vchrtype!='' && 
		<>
		<a href='#' onClick={(e)=>{clearvsaappudak(e);}}  className="nodecor" ><img src='img/noicon.png' border='0' /> clear the table</a>
		&nbsp;&nbsp;&nbsp;&nbsp;
		<input type="button" id='btinsertprepdoc' className="button" value="create payment vouchers" onClick={(e)=>{ getprepinsertdoc(e);  }}  />
		</>
		}
		
</p>  
{/*onKeyUp={(e)=>{setEmail({MESSAGE:''});}}*/}
	<div className="modalsm">
		<div className="modalsm-content">
			<span className="close-button">&times;</span>
			<div align='center' id='modalsmtext' >
			<p align='center' >Type the defer message below.<br/>  It will be emailed to the person who submitted the application</p>
			<textarea rows="7" cols="60" name='emailmsg' onKeyUp={(e)=>{setEmail({MESSAGE:''});}} ></textarea>
			<div align='center' >
			<p>
			<input type='checkbox' id='cbsendemail'  onClick={(e)=>{setemailmessage()}} /><label htmlFor='cbsendemail' className="hand" >The message is ready to be sent.</label>
			</p>
			{dowait.show==true && <><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</>}
			{
			dowait.show==false && 
			<button className="button" style={{width:"180px"}} onClick={(e)=>{senddeferemail()}} >send the message</button>
			}	
			</div>
	
			</div>
		</div>
	</div>


<div id="snackbar">&nbsp;</div>
    </>
  );
  


};


export default RenderWpForm;